<template>
  <div class="btn-group w-100">
    <button
      class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
      data-bs-auto-close="outside" aria-expanded="false"
    >
      {{ $t("selecioneUmCliente", clientes.length, { count: clientes.length }) }}
    </button>
    <ul class="dropdown-menu">
      <li class="dropdown-item">
        <a class="dropdown-item">
          <div class="form-check">
            <input
              id="checkAllClients" class="form-check-input" type="checkbox"
              :checked="clientes.length == clienteArray.length" @input="onCheckedAllClients"
            >
            <label class="form-check-label w-100" for="checkAllClients">{{ $t("todos") }}</label>
          </div>
        </a>
      </li>
      <li v-for="(cliente, index) in clienteArray" :key="index" class="dropdown-item">
        <a class="dropdown-item">
          <div class="form-check">
            <input
              :id="'checku' + index" v-model="clientes" class="form-check-input" :value="cliente.id"
              type="checkbox"
            >
            <label class="form-check-label w-100" :for="'checku'+index">{{ cliente.nomeRazao }}</label>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getClientes } from '@/modules/shared/listService';

export default {
  props: {
    modelValue: { type: Array, required: true },
  },
  emits: ['update:modelValue'],
  data: (props) => ({
    clientes: props.modelValue,
    clienteArray: [],
  }),

  watch: {
    clientes() {
      this.$emit('update:modelValue', this.clientes);
    },
  },
  async mounted() {
    await this.getClientesFilter();
    this.onCheckedAllClients();
  },

  methods: {
    async getClientesFilter() {
      this.clienteArray = await getClientes();
    },
    onCheckedAllClients() {
      this.clientes =
        this.clientes.length === this.clienteArray.length ? [] : this.clienteArray.map((cliente) => cliente.id);
    },
  },
};
</script>
